// Copyright (c) 2021 Deere & Company

import MassLaborRateRequestStatusDetails from '../state/mass-labor-rates-request-details';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const setMassLaborRateRequestDetails = (state, action) =>
    MassLaborRateRequestStatusDetails.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().massLaborRateRequestStatusDetails, action) => {

    const actionTypes = {
        [actions.SET_LABOR_RATE_REQUESTS_DETAILS]: setMassLaborRateRequestDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/reducers/mass-labor-rate-request-status-details.js